module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }